import type { TFunction } from "i18next";

/**
 * SLO'nun görünen adı, kararlı `slo_id` ile anahtarlanır. Sunucunun
 * `description` alanı tek dilli (İngilizce) bir cümledir, ad değildir.
 *
 * Yedek değer kimliğin kendisidir: küme açıktır (`slo_id` TEXT PK, CHECK
 * yok; yeni SLO'lar migration ile gelir), ve kimlik Türkçe ekranda metin
 * gibi değil tanımlayıcı gibi okunur. Ad alanı bu yüzden i18n-extract'in
 * OPEN_DOMAIN_PREFIXES listesindedir.
 */
export function sloName(t: TFunction, sloId: string): string {
  return t(`health.slo_name.${sloId}`, { defaultValue: sloId });
}
